
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_810_478)","stroke":"#FF9E43","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.93 6.936l1.276 4.249m5.607 5.609l4.25 1.275M11.683 12.317l5.76-5.759M4 5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM17 5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM17 18.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM4 15.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_810_478"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    